<template>
  <base-section id="we-help-your-success">
    <base-section-heading
      title="Secure Your Legacy"
      icon="mdi-account-outline"
      outlined
    >
      As the world shifts more towards immersive experiences and 3D content, 4D Labs offers a unique opportunity to capture and preserve artists in a way previously impossible.
      <br></br>
      Capture your legacy, forever.
    </base-section-heading>

    <v-container>
      <v-row>
        <v-col
          v-for="n in 4"
          :key="n"
          cols="6"
          md="3"
        >
          <v-hover>
            <template v-slot="{ hover }">
              <base-img
                :height="$vuetify.breakpoint.mdAndUp ? 400 : 200"
                :src="require(`@/assets/team-${n}.jpg`)"
                color="grey lighten-1"
                flat
                tile
              >
                <v-overlay
                  :value="hover"
                  absolute
                  class="pa-6"
                  color="secondary"
                  opacity=".9"
                >
                  <base-subheading :title="'The Future is Now!'" />

                  <base-body>
                    4D Labs brings your art to 3 dimensions
                  </base-body>
                </v-overlay>
              </base-img>
            </template>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionWeHelpYourSuccess',
  }
</script>
